import React, { useState } from 'react';
import './Home.css';
import Notification from './Notification';

function DoctorsList() {
  const doctors = [
    { name: "Dr Deepak", regNo: "1" },
    { name: "Dr P. Yuvaraj Paul", regNo: "2" },
    { name: "Dr Prakhar Saxena", regNo: "3" },
    { name: "Dr.Santoshi Chourge", regNo: "4" },
    { name: "Dr Vivek Chaurasiya", regNo: "5" },
    { name: "Dr Kajal Gupta", regNo: "6" },
    { name: "Dr Parag Ravindra Wadekar", regNo: "7" },
    { name: "Dr SuryaPrakash Prajapati", regNo: "8" },
    { name: "Dr Indrajeet Verma", regNo: "9" },
    { name: "Dr Dave Dhara", regNo: "10" },
    { name: "Dr Anirban Majumdar", regNo: "11" },
    { name: "Dr Shivangi Pandey", regNo: "12" },
    { name: "Dr Ramani Kaushik", regNo: "13" },
    { name: "Dr Abhishek Raj Nirmal", regNo: "14" },
    { name: "Dr Satyendra Singh", regNo: "15" },
    { name: "Dr Priya Gupta", regNo: "16" },
    { name: "Dr Jyoti Singh", regNo: "17" },
    { name: "Dr Kaushlendra Dwivedi", regNo: "18" },
    { name: "Dr Priyatma Tripathi", regNo: "19" },
    { name: "Dr Ahalya PG", regNo: "20" },
    { name: "Dr Anoop Kumar Saini", regNo: "21" },
    { name: "Dr Arkaprava Das Adhikary", regNo: "22" },
    { name: "Dr Poonam Singh", regNo: "23" },
    { name: "Dr Vadde Venkata Karthik", regNo: "24" },
    { name: "Dr Yogesh Datt Shukla", regNo: "25" },
    { name: "Dr Nayan Biswas", regNo: "26" },
    { name: "Dr Deepshikha Pandey", regNo: "27" },
    { name: "Dr Bhavit Bansal", regNo: "28" },
    { name: "Dr Rhutika Sachin Mahajan", regNo: "29" },
    { name: "Dr Abhinav", regNo: "30" },
    { name: "Dr Shivam Pratap Singh", regNo: "31" },
    { name: "Dr D Sathyanath", regNo: "32" },
    { name: "Dr Laxmi Niwas", regNo: "33" },
    { name: "Dr Munot Simran", regNo: "34" },
    { name: "Dr Seema Bhawan", regNo: "35" },
    { name: "Dr Anthony Marshalin Mothi", regNo: "36" },
    { name: "Dr Mradulika", regNo: "37" },
    { name: "Dr Gaurav Jain", regNo: "38" },
    { name: "Dr Deepa Jothi Mervin Leo", regNo: "39" },
    { name: "Dr Mervin Susairaj Leo", regNo: "40" },
    { name: "Dr Manoj Kumar", regNo: "41" },
    { name: "Dr Komal Shukla", regNo: "42" },
    { name: "Dr Rahul Kumar Gupta", regNo: "43" },
    { name: "Dr Bhagwat Prasad Mishra", regNo: "44" },
    { name: "Dr Sudhir Kumar Chaubey", regNo: "45" },
    { name: "Dr Rhythm Rajavanshi", regNo: "46" },
    { name: "Dr Ashok Kumar Singh", regNo: "47" },
    { name: "Dr Santosh Kumar Yadav", regNo: "48" },
    { name: "Dr Ramnand", regNo: "49" },
    { name: "Dr Ganesh Prasad Agrahari", regNo: "50" },
    { name: "Dr Rajesh Kumar", regNo: "51" },
    { name: "Dr Shivkesh Kumar Singh", regNo: "52" },
    { name: "Dr Saumya Pandey", regNo: "53" },
    { name: "Dr Nikita Sharma", regNo: "54" },
    { name: "Dr Sameerdev Kesarwani", regNo: "55" },
    { name: "Dr Priyanka Baranwal", regNo: "56" },
    { name: "Dr Anand Kumar Sharma", regNo: "57" },
    { name: "Dr Upasna Pathak", regNo: "58" },
    { name: "Dr Amit Kumar Singh", regNo: "59" },
    { name: "Dr Shivangi Saxena", regNo: "60" },
    { name: "Dr Sheroo Singh", regNo: "61" },
    { name: "Dr Pramod Kumar Maddeshiya", regNo: "62" },
    { name: "Dr Narendra Singh", regNo: "63" },
    { name: "Dr Vishesh Parashri", regNo: "64" },
    { name: "Dr Satanam Singh Maurya", regNo: "65" },
    { name: "Dr Anuradha", regNo: "66" },
    { name: "Dr Priya Kumari", regNo: "67" },
    { name: "Dr Sumit Kumar", regNo: "68" },
    { name: "Dr Pooja Sharma", regNo: "69" },
    { name: "Dr Gooty Lalitha Siva Jyoti", regNo: "70" },
    { name: "Dr Teertham Devangan", regNo: "71" },
    { name: "Dr Saba Afreen", regNo: "72" },
    { name: "Dr Priyank Ranjan Malviya", regNo: "73" },
    { name: "Dr Arun Kumar Sharma", regNo: "74" },
    { name: "Dr Sahana Guruwodeyar", regNo: "75" },
    { name: "Dr Aditya Pandey", regNo: "76" },
    { name: "Dr Sweety Singh", regNo: "77" },
    { name: "Dr Praveen C", regNo: "78" },
    { name: "Dr Prabhakar Dubey", regNo: "79" },
    { name: "Dr Vishal Tripathi", regNo: "80" },
    { name: "Dr Arpita Singh", regNo: "81" },
    { name: "Dr Vijay Kumar Pandey", regNo: "82" },
    { name: "Dr Bhavana", regNo: "83" },
    { name: "Dr Deepika", regNo: "84" },
    { name: "Dr Anita Gupta", regNo: "85" },
    { name: "Dr Neha Patel", regNo: "86" },
    { name: "Dr Sanjeev", regNo: "87" },
    { name: "Dr Khalid Shah Goti", regNo: "88" },
    { name: "Dr Aparna Chaturvedi", regNo: "89" },
    { name: "Dr Keerti Kumari", regNo: "90" },
    { name: "Dr Sajina Shahni", regNo: "91" },
    { name: "Dr J Revathi", regNo: "92" },
    { name: "Dr Smiriti", regNo: "93" },
    { name: "Dr Lalduhkimi Ralte", regNo: "94" },
    { name: "Dr Sneha Singh", regNo: "95" },
    { name: "Dr Sunil Singh Yadav", regNo: "96" },
    { name: "Dr Ekta", regNo: "97" },
    { name: "Dr Megha Sharma", regNo: "98" },
    { name: "Dr Kiran Dobhal", regNo: "99" },
    { name: "Dr Gaurav Pathak", regNo: "100" },
    { name: "Dr Dhruv Arya", regNo: "101" },
    { name: "Dr Laxman Prasad Sharma", regNo: "102" },
    { name: "Dr Mrudula Deepak Patil", regNo: "103" },
    { name: "Dr Annalita Leo Antony", regNo: "104" },
    { name: "Dr Solanki Vini Kamleshbai", regNo: "105" },
    { name: "Dr Shivangi Mittal", regNo: "106" },
    { name: "Dr Gulab Rai Tewani", regNo: "107" },
    { name: "Dr Poornima Bansal", regNo: "108" },
    { name: "Dr Gauswami Nikitaben chhotubharthi", regNo: "109" },
    { name: "Dr Meenakshi Rani", regNo: "110" },
    { name: "Dr Varsha Vijay Nathani", regNo: "111" },
    { name: "Dr Deepakshi", regNo: "112" },
    { name: "Dr Kunal Gyanchandani", regNo: "113" },
    { name: "Dr Renu Raj Kashyap", regNo: "114" },
    { name: "Dr Chanchal Vikash", regNo: "115" },
    { name: "Dr Roshan Painuly", regNo: "116" },
    { name: "Dr Brahmbatt Twinkle Nileshkumar", regNo: "117" },
    { name: "Dr Kasim Ali", regNo: "118" },
    { name: "Dr Sindhu H Koushik", regNo: "119" },
    { name: "Dr R Kaushal Iyer", regNo: "120" },
    { name: "Dr Aarish Khan", regNo: "121" },
    { name: "Dr R Rukmani Iyer", regNo: "122" },
    { name: "Dr Saloni Kohli", regNo: "123" },
    { name: "Dr Payal Kumari Pandey", regNo: "124" },
    { name: "Dr Neha Raguwanshi", regNo: "125" },
    { name: "Dr Kajal Bhatt", regNo: "126" },
    { name: "Dr Onam Kumari Verma", regNo: "127" },
    { name: "Dr Salman Khan", regNo: "128" },
    { name: "Dr Gita Pandey", regNo: "129" },
    { name: "Dr Khushboo Yadav", regNo: "130" },
    { name: "Dr Aparna Pandey", regNo: "131" },
    { name: "Dr Mohanakrishnan B", regNo: "132" },
    { name: "Dr Anilka Sachdeva", regNo: "133" },
    { name: "Dr Priya Devi", regNo: "134" },
    { name: "Dr Deepti Kumari", regNo: "135" },
    { name: "Prof. (Dr.) Geetha B. Shetty", regNo: "136" },
    { name: "Dr KM Ritu Sharma", regNo: "137" },
    { name: "Dr Anuj Singh", regNo: "138" },
    { name: "Dr KM Heena Rani", regNo: "139" },
    { name: "Dr Aman Raturi", regNo: "140" },
    { name: "Dr Elanchezhiyan D", regNo: "141" },
    { name: "Dr Ajay Sharma", regNo: "142" },
    { name: "Dr Simran Malhotra", regNo: "143" },
    { name: "Dr Saraswati Tewani", regNo: "144" },
    { name: "Dr Vinudha S", regNo: "145" },
    { name: "Dr Jatin Virendra Parmar", regNo: "146" },
    { name: "Dr Sanjeev Kumar", regNo: "147" },
    { name: "Dr Pushkar Bhalchandra Patthe", regNo: "148" },
    { name: "Dr Aashu Singh", regNo: "149" },
    { name: "Dr Reetu Bhandari", regNo: "150" },
    { name: "Dr Harsh Vardhan Sharma", regNo: "151" },
    { name: "Dr Siji Davis", regNo: "152" },
    { name: "Dr Gaurav Dobhal", regNo: "153" },
    { name: "Dr Shelar Padmavati Mohan", regNo: "154" },
    { name: "Dr Saldanha Shannon Edward", regNo: "155" },
    { name: "Dr Manisha Yadav", regNo: "156" },
    { name: "Dr Priyanka Gupta", regNo: "157" },
    { name: "Dr Chirag Sharma", regNo: "158" },
    { name: "Dr Reuben Lalthazuala", regNo: "159" },
    { name: "Dr Nidhi Bharadwaj", regNo: "160" },
    { name: "Dr Divya Gupta", regNo: "161" },
    { name: "Dr Janhavi Mishra", regNo: "162" },
    { name: "Dr Paramananda", regNo: "163" },
    { name: "Dr Sanjay Yadav", regNo: "164" },
    { name: "Dr Moghariya Kinjal Rameshbhai", regNo: "165" },
    { name: "Dr Sakshi", regNo: "166" },
    { name: "Dr Nikita Godbole", regNo: "167" },
    { name: "Dr Ankit Singh Chauhan", regNo: "168" },
    { name: "Dr Vidhyasagar Yadav", regNo: "169" },
    { name: "Dr Palak Singhal", regNo: "170" },
    { name: "Dr Vinay Kumar Gupta", regNo: "171" },
    { name: "Dr Mohammad Saleem", regNo: "172" },
    { name: "Dr Siddhartho Sankar Roy", regNo: "173" },
    { name: "Dr Chhaya Shreevas", regNo: "174" },
    { name: "Dr Sakshi Singh", regNo: "175" },
    { name: "Dr Katakam Bhavna", regNo: "176" },
    { name: "Dr Aayushi Malik", regNo: "177" },
    { name: "Dr Sachin Kumar", regNo: "178" },
    { name: "Dr Anjana", regNo: "179" },
    { name: "Dr Kanchan Choudhary", regNo: "180" },
    { name: "Dr Anisha Padmakumar Paniker", regNo: "181" },
    { name: "Dr Madhu Yamini", regNo: "182" },
    { name: "Dr Gargi", regNo: "183" },
    { name: "Dr Saurabh Mishra", regNo: "184" },
    { name: "Dr Namrata Amrate", regNo: "185" },
    { name: "Dr Devanshi Goel", regNo: "186" },
    { name: "Dr Mansi Chauhan", regNo: "187" },
    { name: "Dr Navneet Vats", regNo: "188" },
    { name: "Dr Umesh Kumar", regNo: "189" },
    { name: "Dr Manish Janwar", regNo: "190" },
    { name: "Dr M Sathya Joicy", regNo: "191" },
    { name: "Dr Annu", regNo: "192" },
    { name: "Dr Divya", regNo: "193" },
    { name: "Dr Shekhar Choudhary", regNo: "194" },
    { name: "Dr Alok", regNo: "195" },
    { name: "Dr Shristi Sahu", regNo: "196" },
    { name: "Dr Anand Prakash Shukla", regNo: "197" },
    { name: "Dr Anmol Vikash", regNo: "198" },
    { name: "Dr Modi Kanan Divyanshu Kumar", regNo: "199" },
    { name: "Dr Ramesh Namdeo Paware", regNo: "200" },
    { name: "Dr Chandrakant Gupta", regNo: "201" },
    { name: "Dr Perla Venkat Bharath", regNo: "202" },
    { name: "Dr S. Madan Kumar", regNo: "203" },
    { name: "Dr M Kalpana Devi", regNo: "204" },
    { name: "Dr Devang S Karia", regNo: "205" },
    { name: "Dr Naikoti Manasa", regNo: "206" },
    { name: "Dr Raporthi Kavya Sri", regNo: "207" },
    { name: "Dr Paramjeet Kaur", regNo: "208" },
    { name: "Dr Ajinkya Popat Pawar", regNo: "209" },
    { name: "Dr Jyoti Bhgawat Kumbhar", regNo: "210" },
    { name: "Dr Amal Roshan S", regNo: "211" },
    { name: "Dr Swathi PS", regNo: "212" },
    { name: "Dr Khimsurya Priyanka Vasant Kumar", regNo: "213" },
    { name: "Dr Anuradha Rao", regNo: "214" },
    { name: "Dr Susmitha Chowdhary", regNo: "215" },
    { name: "Dr Adithi S Prabhu", regNo: "216" },
    { name: "Dr Ridhi Paida", regNo: "217" },
    { name: "Dr Swathi BS", regNo: "218" },
    { name: "Dr Shipra Chaudhary", regNo: "219" },
    { name: "Dr Milan Maria Joy", regNo: "220" },
    { name: "Dr Richa Kumari", regNo: "221" },
    { name: "Dr Kalluri Lalitha Sumanjali", regNo: "222" },
    { name: "Dr Vilas Eknath Bhor", regNo: "223" },
    { name: "Dr Mohd Arbaj", regNo: "224" },
    { name: "Dr Bobbala Dixita", regNo: "225" },
    { name: "Dr Shubhangi Saxena", regNo: "226" },
    { name: "Dr Jay Mahajan", regNo: "227" },
    { name: "Dr Chaudhari Sharad Shivajirao", regNo: "228" },
    { name: "Dr Anjali Dubey", regNo: "229" },
    { name: "Dr Swikriti Suman Jha", regNo: "230" },
    { name: "Dr Shova Kumari Sharma", regNo: "231" },
    { name: "Dr Varsha Nanasaheb Patil", regNo: "232" },
    { name: "Dr Megha Kochar", regNo: "233" },
    { name: "Dr Kiran Kumar Reddy B", regNo: "234" },
    { name: "Dr Vakeel Khan", regNo: "235" },
    { name: "Dr Menaga K", regNo: "236" },
    { name: "Dr Pranav Ganesh Rao Kawale", regNo: "237" },
    { name: "Dr Hemanshu Sharma", regNo: "238" },
    { name: "Dr Bharatharanjani M", regNo: "239" },
    { name: "Dr Mohammad Aslam Siddiqui", regNo: "240" },
    { name: "Dr Bhoomika Jaiswal", regNo: "241" },
    { name: "Dr Anshika Pathak", regNo: "242" },
    { name: "Dr Madhuri Mahajan", regNo: "243" },
    { name: "Dr Chandrashekar S P", regNo: "244" },
    { name: "Dr Richa Tomar", regNo: "245" },
    { name: "Dr Achom Joshma Devi", regNo: "246" },
    { name: "Dr Deepti Priya", regNo: "247" },
    { name: "Dr Byrapuram Tharun Kumar Reddy", regNo: "248" },
    { name: "Dr Preetee Gond", regNo: "249" },
    { name: "Dr Paresh Ravindra Wadekar", regNo: "250" },
    { name: "Dr Aswani SL", regNo: "251" },
    { name: "Dr Sreegovind R", regNo: "252" },
    { name: "Dr Richa Khandewal", regNo: "253" },
    { name: "Dr Pooja Mishra", regNo: "254" },
    { name: "Dr Anu Sharma", regNo: "255" },
    { name: "Dr Richa Jagtap", regNo: "256" },
    { name: "Dr Meet Parimabhai Patel", regNo: "257" },
    { name: "Dr Ambar Tyagi", regNo: "258" },
    { name: "Dr Adil", regNo: "259" },
    { name: "Dr Sandeep Kumar Jangir", regNo: "260" },
    { name: "Dr Selva Kumar K", regNo: "261" },
    { name: "Dr Mamta Nishant Chawla", regNo: "262" },
    { name: "Dr Devasis Meher", regNo: "263" },
    { name: "Dr Ajeet Rana", regNo: "264" },
    { name: "Dr Himani", regNo: "265" },
    { name: "Dr Vaishnavi K Goudappanavan", regNo: "266" },
    { name: "Dr Guni Gupta", regNo: "267" },
    { name: "Dr Nikita Panwar", regNo: "268" },
    { name: "Dr Peetha Siva Narayana", regNo: "269" },
    { name: "Dr Diksha Rena", regNo: "270" },
    { name: "Dr Muneer Alam", regNo: "271" },
    { name: "Dr Kalpana Bhandari", regNo: "272" },
    { name: "Dr Pandey Amrita Sudhakar", regNo: "273" },
    { name: "Dr Himanshu", regNo: "274" },
    { name: "Dr Ripudaman Singh Chauhan", regNo: "275" },
    { name: "Dr Shweta Chauhan", regNo: "276" },
    { name: "Dr Tripti Nalge", regNo: "277" },
    { name: "Dr Deepak Singh", regNo: "278" },
    { name: "Dr Priyanka Tiwari", regNo: "279" },
    { name: "Dr Radha Bagil", regNo: "280" },
    { name: "Dr Yograj Arya", regNo: "281" },
    { name: "Dr Kavikuil Rajashri", regNo: "282" },
    { name: "Dr Jyothi Madhur", regNo: "283" },
    { name: "Dr Vikas Danodiya", regNo: "284" },
    { name: "Dr Roshni Mistry", regNo: "285" },
    { name: "Dr Avisana Virendra", regNo: "286" },
    { name: "Dr Krithika R", regNo: "287" },
    { name: "Dr Avinash Kumar Mishra", regNo: "288" },
    { name: "Dr Sakshi Janghela", regNo: "289" },
    { name: "Dr Patel Purva Bhupendra", regNo: "290" },
    { name: "Dr Rishika Singh", regNo: "291" },
    { name: "Dr Roshni Dubey", regNo: "292" },
    { name: "Dr Satya Lakshmi", regNo: "293" },
    { name: "Dr Shantanu Mishra", regNo: "294" },
    { name: "Dr Pooja G", regNo: "295" },
    { name: "Dr Soumya Pateriya", regNo: "296" },
    { name: "Dr Nagrale Shubhangi Tukaram", regNo: "297" },
    { name: "Dr Abhishek Chaubey", regNo: "298" },
    { name: "Dr M.A. Rama Murthy", regNo: "299" },
    { name: "Dr Ranjan Kumar", regNo: "300" },
    { name: "Dr Ranjita Singh", regNo: "301" },
    { name: "Dr Vama Jain", regNo: "302" },
    { name: "Dr M. Nagalakshmi", regNo: "303" },
    { name: "Dr Kajal Totlani", regNo: "304" },
    { name: "Dr Alok Kumar Pandey", regNo: "305" },
    { name: "Dr Neeshma CA", regNo: "306" },
    { name: "Dr Divyasarathy S", regNo: "307" },
    { name: "Dr Anirudh Arya", regNo: "308" },
    { name: "Dr Renuka Sharma", regNo: "309" },
    { name: "Dr Mandala Sathwik", regNo: "310" },
    { name: "Dr Jyoti Kumari Srivatsava", regNo: "311" },
    { name: "Dr Geetanjali Maneshwar", regNo: "312" },
    { name: "Dr Divya Chandil", regNo: "313" },
    { name: "Dr Navdeep Saxena", regNo: "314" },
    { name: "Dr Harshvardhan S", regNo: "315" },
    { name: "Dr Yashvi Banvat", regNo: "316" },
    { name: "Dr Anekha Choudhary", regNo: "317" },
    { name: "Dr Kodakalla Shanti Sree", regNo: "318" },
    { name: "Dr SS Arvindar", regNo: "319" },
    { name: "Dr Dhanalakhsmi", regNo: "320" },
    { name: "Dr Ram Saran Verma", regNo: "321" },
    { name: "Dr Priya Bohra", regNo: "322" },
    { name: "Dr Joginder", regNo: "323" },
    { name: "Dr Murlidhara Reddy V", regNo: "324" },
    { name: "Dr Anamika Singh Meena", regNo: "325" },
    { name: "Dr Vikasa Kamath M", regNo: "326" },
    { name: "Dr Nikhat Shah", regNo: "327" },
    { name: "Dr Ashwini Rohita", regNo: "328" },
    { name: "Dr Ragathaman RA", regNo: "329" },
    { name: "Dr Soundara Pandian", regNo: "330" },
    { name: "Dr Gopi P", regNo: "331" },
    { name: "Dr P Naresh Kumar", regNo: "332" },
    { name: "Dr Diksha Ojha", regNo: "333" },
    { name: "Dr Safeera Noormahal", regNo: "334" },
    { name: "Dr Spoorthi Shetty", regNo: "335" },
    { name: "Dr Rishabh Singh", regNo: "336" },
    { name: "Dr Anchal Bansal", regNo: "337" },
    { name: "Dr Jain Nidhi Girish", regNo: "338" },
    { name: "Dr Pushpanjali Dubey", regNo: "339" },
    { name: "Dr G Praveena", regNo: "340" },
    { name: "Dr Riya R", regNo: "341" },
    { name: "Dr Ankita Sisodiya", regNo: "342" },
    { name: "Dr Komal Vijaybhai Dubal", regNo: "343" },
    { name: "Dr Parveen", regNo: "344" },
    { name: "Dr Anchal", regNo: "345" },
    { name: "Dr Bharti Jaiswal", regNo: "346" },
    { name: "Dr Garima", regNo: "347" },
    { name: "Dr Ankit Chaoudhary", regNo: "348" },
    { name: "Dr Swati Sharma", regNo: "349" },
    { name: "Dr R Swetha", regNo: "350" },
    { name: "Dr Shiba Jha", regNo: "351" },
    { name: "Dr Gauri Dubey", regNo: "352" },
    { name: "Dr Ramaniah M", regNo: "353" },
    { name: "Dr Shubhoda Thorat", regNo: "354" },
    { name: "Dr Sangeetha Keshwatkar", regNo: "355" },
    { name: "Dr Harshini Iyengar", regNo: "356" },
    { name: "Dr Samom Amarjit Singh", regNo: "357" },
    { name: "Dr Pinki Dangi", regNo: "358" },
    { name: "Dr Sanil SM", regNo: "359" },
    { name: "Dr Vinod Kumar", regNo: "360" },
    { name: "Dr Malini Kamal Gowda", regNo: "361" },
    { name: "Dr Gokul Prasad Sharma", regNo: "362" },
    { name: "Dr Thumpally Sindhu Sravani", regNo: "363" },
    { name: "Dr Aradhana Sharma", regNo: "364" },
    { name: "Dr Anuja Anand", regNo: "365" },
    { name: "Dr NV Gnanadeep Tatavarti", regNo: "366" },
    { name: "Dr Rudani Sharma", regNo: "367" },
    { name: "Dr Edla Srinivas Reddy", regNo: "368" },
    { name: "Dr Edla Usha Sri", regNo: "369" },
    { name: "Dr Sabbarapu Rajesh Kumar", regNo: "370" },
    { name: "Dr Namrata Dubey", regNo: "371" },
    { name: "Dr Yumnam Thajamanbi Chanu", regNo: "372" },
    { name: "Dr Vipul Chauhan", regNo: "373" },
    { name: "Dr Riya Tiwari", regNo: "374" },
    { name: "Dr Anamika Kumari", regNo: "375" },
    { name: "Dr Aastha Patidar", regNo: "376" },
    { name: "Dr Shaik Meharunnise", regNo: "377" },
    { name: "Dr Abish M", regNo: "378" },
    { name: "Dr Deshpande Shraddha Pravin", regNo: "379" },
    { name: "Dr Shreya Dixit", regNo: "380" },
    { name: "Dr T Sravanthi", regNo: "381" },
    { name: "Dr Shahnaaz Begum", regNo: "382" },
    { name: "Dr Anjali Srivastava", regNo: "383" },
    { name: "Dr Mukesh", regNo: "384" },
    { name: "Dr Ekta Venkatesh", regNo: "385" },
    { name: "Dr K Thangaraj", regNo: "386" },
    { name: "Dr Lavina Gangwani", regNo: "387" },
    { name: "Dr Vibhas K", regNo: "388" },
    { name: "Dr Diksha Vig", regNo: "389" },
    { name: "Dr Anand R", regNo: "390" },
    { name: "Dr Preety Chakradhari", regNo: "391" },
    { name: "Dr Bairi Srinivas", regNo: "392" },
    { name: "Dr Ananya BS", regNo: "393" },
    { name: "Dr Pranab Das", regNo: "394" },
    { name: "Dr Kuppam Divya Sree", regNo: "395" },
    { name: "Dr Bongu Prathima Kumari", regNo: "396" },
    { name: "Dr Nitin Rathod", regNo: "397" },
    { name: "Dr Garima Mahajan", regNo: "398" },
    { name: "Dr Aarfa Siddiqui", regNo: "399" },
    { name: "Dr Shilpa Shah", regNo: "400" },
    { name: "Dr Vanitha M", regNo: "401" },
    { name: "Dr Modha Pooja Dhirajlal", regNo: "402" },
    { name: "Dr Yogesh Kumar Pant", regNo: "403" },
    { name: "Dr Chilakamarthi Durga Pravallika", regNo: "404" },
    { name: "Dr Konika Singh", regNo: "405" },
    { name: "Dr Brijesh Kumar Mishra", regNo: "406" },
    { name: "Dr Gayatri Garg", regNo: "407" },
    { name: "Dr Mohit Patidar", regNo: "408" },
    { name: "Dr Banasri Gogoi", regNo: "409" },
    { name: "Dr Arpita Rawat", regNo: "410" },
    { name: "Dr Devi Sheila S", regNo: "411" },
    { name: "Dr Arshneen Khan", regNo: "412" },
    { name: "Dr Kathi Akhileshwari", regNo: "413" },
    { name: "Dr Keerthi Kousalya", regNo: "414" },
    { name: "Dr Mandala Sarju", regNo: "415" },
    { name: "Dr Mandala Neelam Sarju", regNo: "416" },
    { name: "Dr Purna Prabhu", regNo: "417" },
    { name: "Dr G Monic Sravanthi", regNo: "418" },
    { name: "Dr Anoop Kumar T", regNo: "419" },
    { name: "Dr Krithika Anand Iyer", regNo: "420" },
    { name: "Dr Anjali Edayillam", regNo: "421" },
    { name: "Dr Vasundhara VR", regNo: "422" },
    { name: "Dr Prema Veena Palapanchala", regNo: "423" },
    { name: "Dr B Bheemiah", regNo: "424" },
    { name: "Dr Angphen O Phom", regNo: "425" },
    { name: "Dr Dziesevilie Talie", regNo: "426" },
    { name: "Dr Kethavathu Devaswamy Naik", regNo: "427" },
    { name: "Dr Vaishnavi Dhananjay Aundhekar", regNo: "428" },
    { name: "Dr Anchal Gond", regNo: "429" },
    { name: "Dr Aradhana", regNo: "430" },
    { name: "Dr Aishwariya Virupakshi Algur", regNo: "431" },
    { name: "Dr Parth Bharadwaj", regNo: "432" },
    { name: "Dr Charu Singh", regNo: "433" },
    { name: "Dr Suchi Smitta Rai", regNo: "434" },
    { name: "Dr Shreya Arya", regNo: "435" },
    { name: "Dr Govind Kumar Sinha", regNo: "436" },
    { name: "Dr Gopal Krishna", regNo: "437" },
    { name: "Dr Akansha Singh", regNo: "438" },
    { name: "Dr Abhishek Kumar", regNo: "439" },
    { name: "Dr Harshita Pundhir", regNo: "440" },
    { name: "Dr R Preethi", regNo: "441" },
    { name: "Dr Krishna Devi K", regNo: "442" },
    { name: "Dr Mohammad Rashid Khan", regNo: "443" },
    { name: "Dr Athulya Pillai", regNo: "444" },
    { name: "Dr Jitendra Kumber Digraje", regNo: "445" },
    { name: "Dr C Raghunandan", regNo: "446" },
    { name: "Dr Sourav Biswas", regNo: "447" },
    { name: "Dr Prachi Rani", regNo: "448" },
    { name: "Dr Prachi Negi", regNo: "449" },
    { name: "Dr Hardeep Kaur", regNo: "450" },
    { name: "Dr Christina halhmangaihzuali", regNo: "451" },
    { name: "Dr Nivethita L", regNo: "452" },
    { name: "Dr Moventhan A", regNo: "453" },
    { name: "Dr Pyagang Mado", regNo: "454" },
    { name: "Dr Uppalapati Sri Hari", regNo: "455" },
    { name: "Dr Eeri Arunsai", regNo: "456" },
    { name: "Dr Anil Kumar M", regNo: "457" },
    { name: "Dr Sagar Manoj Sharma", regNo: "458" },
    { name: "Dr Bini M", regNo: "459" },
    { name: "Dr Neikilvonuo Tsira", regNo: "460" },
    { name: "Dr Intures Venkata Kamalendra Babu", regNo: "461" },
    { name: "Dr Carolyn Vungstaching", regNo: "462" },
    { name: "Dr Boogaraja Sairaju", regNo: "463" },
    { name: "Dr Shaik Boobin Banu", regNo: "464" },
    { name: "Dr Manisha Kumari", regNo: "465" },
    { name: "Dr Patil Kapil Satgonda", regNo: "466" },
    { name: "Dr Chandraprakash", regNo: "467" },
    { name: "Dr Kondapi Veda Ananta Sai Sarath Chandra", regNo: "468" },
    { name: "Dr Ballipalli Sandhya", regNo: "469" },
    { name: "Dr Chennamraju Venkaliwara Raju", regNo: "470" },
    { name: "Dr Kateri Manasa", regNo: "471" },
    { name: "Dr Kodali Mohana Snighda", regNo: "472" },
    { name: "Dr Deepak Paudel", regNo: "473" },
    { name: "Dr Deepali Saxena", regNo: "474" },
    { name: "Dr Manthena Vasthavi", regNo: "475" },
    { name: "Dr Garima Garg", regNo: "476" },
    { name: "Dr Junaidill Mubarak M", regNo: "477" },
    { name: "Dr Aditya Lakhwaan", regNo: "478" },
    { name: "Dr Rayabarapu Eswar Sirdi", regNo: "479" },
    { name: "Dr Arpan Kumari", regNo: "480" },
    { name: "Dr Bhuvnesh Agarwal", regNo: "481" },
    { name: "Dr Shraddha Nimbark", regNo: "482" },
    { name: "Dr Yumnam Ratankumar Meitei", regNo: "483" },
    { name: "Dr Akila Laishram", regNo: "484" },
    { name: "Dr Nimeesha MJ", regNo: "485" },
    { name: "Dr Vanshika Chaudhary", regNo: "486" },
    { name: "Dr Yellapu Shanmukha Sri Vidya", regNo: "487" },
    { name: "Dr Tazmani Sultana", regNo: "488" },
    { name: "Dr Reshma", regNo: "489" },
    { name: "Dr S Shravani", regNo: "490" },
    { name: "Dr Priyanka", regNo: "491" },
    { name: "Dr V Venugopal", regNo: "492" },
    { name: "Dr Sovan Mangal", regNo: "493" },
    { name: "Dr Shikha Hajare", regNo: "494" },
    { name: "Dr Abhishek Kumar", regNo: "495" },
    { name: "Dr Mukesh Kumar Sharma", regNo: "496" },
    { name: "Dr Manish Potphode", regNo: "497" },
    { name: "Dr Shyambhadur", regNo: "498" },
    { name: "Dr Manpreet Kaur", regNo: "499" },
    { name: "Dr Ashwini Adkoi", regNo: "500" },
    { name: "Dr Akash Bisone", regNo: "501" },
    { name: "Dr Chandala Rishita", regNo: "502" },
    { name: "Dr Shefali Bharadwaj", regNo: "503" },
    { name: "Dr Sudarmahilnan AP", regNo: "504" },
    { name: "Dr Thenmalar", regNo: "505" },
    { name: "Dr Swati", regNo: "506" },
    { name: "Dr Anusiya", regNo: "507" },
    { name: "Dr Poulami", regNo: "508" },
    { name: "Dr S Hari Ganesh", regNo: "509" },
    { name: "Dr Deepika Tomar", regNo: "510" },
    { name: "Dr Rajan", regNo: "511" },
    { name: "Dr Nissy R", regNo: "512" },
    { name: "Dr Swathy J", regNo: "513" },
    { name: "Dr Vivek Chand", regNo: "514" },
    { name: "Dr Pragati Agarwal", regNo: "515" },
    { name: "Dr Shinde Dnyanesh Wari Sachin", regNo: "516" },
    { name: "Dr Darshan Herimath", regNo: "517" },
    { name: "Dr Thomas Paul", regNo: "518" },
    { name: "Dr Atul Vivek", regNo: "519" },
    { name: "Dr Irshad", regNo: "520" },
    { name: "Dr Harpeet Singh", regNo: "521" },
    { name: "Dr Kakarala Sri Lakshmi Pavani", regNo: "522" },
    { name: "Dr Gokulkrishnan B", regNo: "523" },
    { name: "Dr Dushyant Jamdagni", regNo: "524" },
    { name: "Dr Surjeet Singh", regNo: "525" },
    { name: "Dr Jenifar Prinee PH", regNo: "526" },
    { name: "Dr Akansha", regNo: "527" },
    { name: "Dr Aparna Sreenivasan", regNo: "528" },
    { name: "Dr Kodali Lakshmi Siromani", regNo: "529" },
    { name: "Dr Shivakameshwari D", regNo: "530" },
    { name: "Dr Ravi Kumar", regNo: "531" },
    { name: "Dr Sai Charan Reddy Bhumavarapu", regNo: "532" },
    { name: "Dr Gopineti Sumana", regNo: "533" },
    { name: "Dr Durga S", regNo: "534" },
    { name: "Dr Aravindan V", regNo: "535" },
    { name: "Dr Siddharth Shankar", regNo: "536" },
    { name: "Dr Dilip", regNo: "537" },
    { name: "Dr Deepankar Malik", regNo: "538" },
    { name: "Dr Sneh Kant Gaur", regNo: "539" },
    { name: "Dr Prerana Vishwas Awasarmal", regNo: "540" },
    { name: "Dr Riya Singh", regNo: "541" },
    { name: "Dr Lalit Sankhla", regNo: "542" },
    { name: "Dr Sunder", regNo: "543" },
    { name: "Dr Akriti Bharti", regNo: "544" },
    { name: "Dr Shalini Thakur", regNo: "545" },
    { name: "Dr Karan Pratap Bhullar", regNo: "546" },
    { name: "Dr Goutam", regNo: "547" },
    { name: "Dr Bollareddy Sukeerthi", regNo: "548" },
    { name: "Dr Anukool Deevedi", regNo: "549" },
    { name: "Dr Kartika", regNo: "550" },
    { name: "Dr Sneha V", regNo: "551" },
    { name: "Dr Sunil Lovewanshi", regNo: "552" },
    { name: "Dr Sushmita Singh", regNo: "553" },
    { name: "Dr Adiba Khan", regNo: "554" },
    { name: "Dr Akansha Singh", regNo: "555" },
    { name: "Dr Aparna Patel", regNo: "556" },
    { name: "Dr Anuj Sharma", regNo: "557" },
    { name: "Dr Abhimanyu Jangid", regNo: "558" },
    { name: "Dr Lily Parmawii", regNo: "559" },
    { name: "Dr Sapna", regNo: "560" },
    { name: "Dr N.Arun Kumar", regNo: "561" },
    { name: "Dr Sneha Prasad", regNo: "562" },
    { name: "Dr Ashwini", regNo: "563" },
    { name: "Dr Priyanjali", regNo: "564" },
    { name: "Dr Jyoti", regNo: "565" },
    { name: "Dr Arushi Paul", regNo: "566" },
    { name: "Dr Niharika Ahuja", regNo: "567" },
    { name: "Dr Muskan Dhankar", regNo: "568" },
    { name: "Dr Niharika", regNo: "569" },
    { name: "Dr Shagun Ghagre", regNo: "570" },
    { name: "Dr Praneel Melvin Rodrigues", regNo: "571" },
    { name: "Dr Ishika Saha", regNo: "572" },
    { name: "Dr Hari Krishna Gudivada", regNo: "573" },
    { name: "Dr Sheetal Patidar", regNo: "574" },
    { name: "Dr Sophia Deva Kirubai P", regNo: "575" },
    { name: "Dr Pratap Singh P", regNo: "576" },
    { name: "Dr Tanvi", regNo: "577" },
    { name: "Dr Bharath M", regNo: "578" },
    { name: "Dr Jyoti Jat", regNo: "579" },
    { name: "Dr Dhivagar S", regNo: "580" },
    { name: "Dr Bineet Singh", regNo: "581" },
    { name: "Dr Bibha", regNo: "582" },
    { name: "Dr Sahib aropiya", regNo: "583" },
    { name: "Dr Karthik", regNo: "584" },
    { name: "Dr Bornoshree Bori", regNo: "585" },
    { name: "Dr Rohit Kumar Navgansh", regNo: "586" },
    { name: "Dr Ashwini", regNo: "587" },
    { name: "Dr Nazma Sultana", regNo: "588" },
    { name: "Dr Ankita Upadhyay", regNo: "589" },
    { name: "Dr Bharati Basnett", regNo: "590" },
    { name: "Dr Ajay", regNo: "591" },
    { name: "Dr Janhavi", regNo: "592" },
    { name: "Dr Mudang That", regNo: "593" },
    { name: "Dr M Bhargavi", regNo: "594" },
    { name: "Dr Neha Khaidem", regNo: "595" },
    { name: "Dr Asharani Devi Maiban", regNo: "596" },
    { name: "Dr Swarnlekha", regNo: "597" },
    { name: "Dr Renuka Chettri", regNo: "598" },
    { name: "Dr Simran Gupta", regNo: "599" },
    { name: "Dr Varsha Kiran PV", regNo: "600" },
    { name: "Dr Pushkar Dutt", regNo: "601" },
    { name: "Dr Jutika Bhuyan", regNo: "602" },
    { name: "Dr Rama Pokhrel", regNo: "603" },
    { name: "Dr Abhishek Dubey", regNo: "604" },
    { name: "Dr Divya Chaudhary", regNo: "605" },
    { name: "Dr Rangeay Raghaw Mishra", regNo: "606" },
    { name: "Dr Shruti Baid", regNo: "607" },
    { name: "Dr Ansh Tiwari", regNo: "608" },
    { name: "Dr Dhiren Ajit Nair", regNo: "609" },
    { name: "Dr Prachi Priya Pandey", regNo: "610" },
    { name: "Dr Sathyachandran K", regNo: "611" },
    { name: "Dr Poornima K Bhat", regNo: "612" },
    { name: "Dr Tanya Jain", regNo: "613" },
    { name: "Dr Suryansh kansal", regNo: "614" },
    { name: "Dr Surabhi Vinayak Khojokar", regNo: "615" },
    { name: "Dr Jishnu Jai", regNo: "616" },
    { name: "Dr Panchakshari Srushti Umakant", regNo: "617" },
    { name: "Dr Rithik Narayanan", regNo: "618" },
    { name: "Dr Muskan Chouksey", regNo: "619" },
    { name: "Dr Neha Kanaujia", regNo: "620" },
    { name: "Dr Kamal Singh Katara", regNo: "621" },
    { name: "Dr Gorang Tyagi", regNo: "622" },
    { name: "Dr R Rajalakshmi", regNo: "623" },
    { name: "Dr Vaishali Kulshrestha", regNo: "624" },
    { name: "Dr Ananthi RS", regNo: "625" },
    { name: "Dr Seema Dixit", regNo: "626" },
    { name: "Dr Shruti Das", regNo: "627" },
    { name: "Dr Palak Khargonkar", regNo: "628" },
    { name: "Dr Harsh Kumar", regNo: "629" },
    { name: "Dr Aditi Rawat", regNo: "630" },
    { name: "Dr Shivangi", regNo: "631" },
    { name: "Dr Nitesh Kumawat", regNo: "632" },
    { name: "Dr Neha Sharma", regNo: "633" },
    { name: "Dr Drishti Badtiya", regNo: "634" },
    { name: "Dr Vipin Pant", regNo: "635" },
    { name: "Dr K Siddhartha Chandra", regNo: "636" },
    { name: "Dr Arvashi Pandey", regNo: "637" },
    { name: "Dr Dimple Moryani", regNo: "638" },
    { name: "Dr Ayushi Thakur", regNo: "639" },
    { name: "Dr Jassika Palak Karani", regNo: "640" },
    { name: "Dr Kashyap Gautam Kumar", regNo: "641" },
    { name: "Dr Barmali Saha", regNo: "642" },
    { name: "Dr Avnish Nagar", regNo: "643" },
    { name: "Dr Priyadarshini Wahengbam", regNo: "644" },
    { name: "Dr Rishabh Prabhakar", regNo: "645" },
    { name: "Dr Poijamozhi V", regNo: "646" },
    { name: "Dr Manu Chaudhary", regNo: "647" },
    { name: "Dr Shivangi Chaudhary", regNo: "648" },
    { name: "Dr Mohit Kumar", regNo: "649" },
    { name: "Dr Kash Singh", regNo: "650" },
    { name: "Dr Amar Govind J B", regNo: "651" },
    { name: "Dr Lovepreet Kaur", regNo: "652" },
    { name: "Dr Ushagayatri Oruganti", regNo: "653" },
    { name: "Dr Sivaraman K", regNo: "654" },
    { name: "Dr Snehlata Murmu", regNo: "655" },
    { name: "Dr Anshi Sharma", regNo: "656" },
    { name: "Dr Ashutosh Chaudhary", regNo: "657" },
    { name: "Dr Chetanprabha M Patil", regNo: "658" },
    { name: "Dr Lakshay Verma", regNo: "659" },
    { name: "Dr Shrikant Verma", regNo: "660" },
    { name: "Dr Jyoti Kathait", regNo: "661" },
    { name: "Dr Dharamraj S", regNo: "662" },
    { name: "Dr Mahima Pandey", regNo: "663" },
    { name: "Dr Nikita", regNo: "664" },
    { name: "Dr Sarita Devi", regNo: "665" },
    { name: "Dr Krishnakumari Huidrom", regNo: "666" },
    { name: "Dr Sobhalakshmi Huidrom", regNo: "667" },
    { name: "Dr Ratnesh", regNo: "668" },
    { name: "Dr Akib Ali", regNo: "669" },
    { name: "Dr Sujata", regNo: "670" },
    { name: "Dr Julie Zorsangkimi", regNo: "671" },
    { name: "Dr Smriti Goswami", regNo: "672" },
    { name: "Dr Rahul Kumar", regNo: "673" },
    { name: "Dr Monika Arya", regNo: "674" },
    { name: "Dr Sumit Kumar", regNo: "675" },
    { name: "Dr Aastha Sharma", regNo: "676" },
    { name: "Dr Abhilash Kumar", regNo: "677" },
    { name: "Dr Geetha B Shetty", regNo: "678" },
    { name: "Dr Dhruja Varshini V S", regNo: "679" },
    { name: "Dr Mithun S V", regNo: "680" },
    { name: "Dr Mohd Hamza Hamid", regNo: "681" },
    { name: "Dr Laya Niveatha V", regNo: "682" },
    { name: "Dr Muskan Nirwan", regNo: "683" },
    { name: "Dr Buragaya Metha Gayatri", regNo: "684" },
    { name: "Dr Shivendra Tripathi", regNo: "685" },
    { name: "Dr Dharmveer Singh", regNo: "686" },
    { name: "Dr P Saranyan", regNo: "687" },
    { name: "Dr Chava Sumathi", regNo: "688" },
    { name: "Dr R S Sugin Herbert", regNo: "689" },
    { name: "Dr Rohini S", regNo: "690" },
    { name: "Dr Pooja Agarwal", regNo: "691" },
    { name: "Dr Vasuki Amburajan", regNo: "692" },
    { name: "Dr Abhilash S C", regNo: "693" },
    { name: "Dr Elseena", regNo: "694" },
    { name: "Dr Karunvarshini K", regNo: "695" },
    { name: "Dr Sharmila Selvaraj", regNo: "696" },
    { name: "Dr Afreen Shaikh", regNo: "697" },
    { name: "Dr Naveen K N", regNo: "698" },
    { name: "Dr Shiny Maibam", regNo: "699" },
    { name: "Dr Pushpa Jenifer P", regNo: "700" },
    { name: "Dr Ashok Murugan", regNo: "701" },
    { name: "Dr Ashok Kumar", regNo: "702" },
    { name: "Dr Divya Elangbam", regNo: "703" },
    { name: "Dr Patel Marigiben Bharatkumar", regNo: "704" },
    { name: "Dr Anushree Chauhan", regNo: "705" },
    { name: "Dr Anburani K", regNo: "706" },
    { name: "Dr R Muthukumar", regNo: "707" },
    { name: "Dr Trashita Mouraya", regNo: "708" },
    { name: "Dr Divya Panwar", regNo: "709" },
    { name: "Dr Preethi Pushkarani T", regNo: "710" },
    { name: "Dr Tamilmani Kathirvel", regNo: "711" },
    { name: "Dr Jincemol P C", regNo: "712" },
    { name: "Dr Sukumar Chinnasamy", regNo: "713" },
    { name: "Dr Lalit Bihari Joshi", regNo: "714" },
    { name: "Dr Rajiv Kumar Murugan", regNo: "715" },
    { name: "Dr Talari Karteek", regNo: "716" },
    { name: "Dr Shan K B", regNo: "717" },
    { name: "Dr Mohd Ujjair", regNo: "718" },
    { name: "Dr Kowsalya Raja", regNo: "719" },
    { name: "Dr Nikhil Dilip Patil", regNo: "720" },
    { name: "Dr Haryani Pratiksha Dipakbhai", regNo: "721" },
    { name: "Dr Trupti Naresh Rathi", regNo: "722" },
    { name: "Dr Joseph Samuel J", regNo: "723" },
    { name: "Dr Sumegh Nandanwar", regNo: "724" },
    { name: "Dr Gautam Singh", regNo: "725" },
    { name: "Dr Santosh John J", regNo: "726" },
    { name: "Dr Joshi Helen L", regNo: "727" },
    { name: "Dr Priyanga Manivasagam", regNo: "728" },
    { name: "Dr Yogesh Potdar", regNo: "729" },
    { name: "Dr Gnanapriya T", regNo: "730" },
    { name: "Dr Bhaskar Selvam", regNo: "731" },
    { name: "Dr Shreya Sundarrajan", regNo: "732" },
    { name: "Dr G Ramesh", regNo: "733" },
    { name: "Dr Pavan K S", regNo: "734" },
    { name: "Dr Atchaya Velmurugan", regNo: "735" },
    { name: "Dr Sarathi Sadhasivam", regNo: "736" },
    { name: "Dr Rudranshi Nehra", regNo: "737" },
    { name: "Dr U S Susha", regNo: "738" },
    { name: "Dr Rupam Dwivedi", regNo: "739" },
    { name: "Dr Rajat Soni", regNo: "740" },
    { name: "Dr Sudhakar A M", regNo: "741" },
    { name: "Dr Sangevi S. Anbalagan", regNo: "742" },
    { name: "Dr Shweta Sharma", regNo: "743" },
    { name: "Dr Garima Kumari", regNo: "744" },
    { name: "Dr Savitha M", regNo: "745" },
    { name: "Dr M Ganeshprabhu", regNo: "746" },
    { name: "Dr John Jebakumar Joshua", regNo: "747" },
    { name: "Dr Poonkuntan Balusamy", regNo: "748" },
    { name: "Dr Mohd Arkam A J", regNo: "749" },
    { name: "Dr Mukul Yadav", regNo: "750" }
  ];

  const [searchQuery, setSearchQuery] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="home">
      {/* Header */}
      <header className="top-header">
        <div className="header-inner">
          <div className="header-logos">
            <a href="/" aria-label="Go to home page">
              <img src="img/nrb.png" alt="Logo 1" className="header-logo-img" />
            </a>
            <a href="https://ayush.gov.in/" target="_blank" rel="noopener noreferrer" aria-label="Open Ministry of Ayush website">
              <img src="img/MOA.png" alt="Logo 2" className="header-logo-img" />
            </a>
          </div>

          <div className="topbar-marquee-group">
            <Notification />
            <Notification
              variant="danger"
              messages={[
                'State registration is mandatory as part of the NRB-HPR integrated registration process. Kindly download the HPR Certificate and I-card from HPR Portal through this link https://nhpr.abdm.gov.in/nhpr/v4/login'
              ]}
            />
          </div>
        </div>
      </header>

      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-inner">
          <button
            className="nav-toggle"
            aria-label="Toggle navigation"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
          </button>
          <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
            <li><a href="/">Home</a></li>
            <li className="nav-dropdown">
              <a href="#about">About</a>
              <ul className="dropdown-menu">
                <li><a href="/about-us">About NRB</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/" target="_blank" rel="noopener noreferrer">About NIN</a></li>
              </ul>
            </li>
            <li><a href="/constitution">Constitution of NRB</a></li>
            <li className="nav-dropdown">
              <a href="#directory">NRB Directory</a>
              <ul className="dropdown-menu">
                <li><a href="/doctors-list">List of Doctors Registered</a></li>
                <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#events">Events</a>
              <ul className="dropdown-menu">
                <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
                <li><a href="/gallery">News & Events</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#resources">Resources</a>
              <ul className="dropdown-menu">
                <li><a href="/state-boards">State Registration Board</a></li>
                <li><a href="/medical-colleges">State Wise Yoga & Naturopathy Medical Colleges in India, 2023</a></li>
                <li><a href="/who-naturopathic-workforce">World Health Organisation (WHO) Region wise listing of countries with Naturopathic Workforce 2023</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#others">Others</a>
              <ul className="dropdown-menu">
                <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/nisargopcharVartaArchive" target="_blank" rel="noopener noreferrer">Nisargopchar Varta</a></li>
              </ul>
            </li>
            <li><a href="/contact">Contact</a></li>
            <li className="nav-cta-mobile"><a href="https://app.nrb.net.in/#/session/signin/step1">Register</a></li>
          </ul>
          <a href="https://app.nrb.net.in/#/session/signin/step1" className="nav-cta">Click here to Register</a>
        </div>
      </nav>

      {/* Doctors List Page */}
      <div className="doctors-list-page">
        <div className="doctors-hero">
          <h1 className="doctors-main-heading">List of Doctors Registered</h1>
          <p className="doctors-subtitle">Central Registration of Naturopathy Practitioners</p>
        </div>

        <div className="content-wrapper">
          <div className="search-container">
            <input
              type="text"
              placeholder="Search by doctor name or registration number..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
            <span className="search-icon">🔍</span>
          </div>

          <div className="doctors-stats">
            <p className="total-count">
              {searchQuery ? `Showing ${doctors.filter(doctor => 
                doctor.name.toLowerCase().includes(searchQuery.toLowerCase()) || 
                doctor.regNo.includes(searchQuery)
              ).length} of ${doctors.length} doctors` : `Total Registered Doctors: `}
              {!searchQuery && <strong>{doctors.length}</strong>}
            </p>
          </div>

          <div className="doctors-table-wrap">
            <table className="doctors-table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Name of the Candidate</th>
                  <th>Registration No.</th>
                </tr>
              </thead>
              <tbody>
                {doctors
                  .filter(doctor => 
                    doctor.name.toLowerCase().includes(searchQuery.toLowerCase()) || 
                    doctor.regNo.includes(searchQuery)
                  )
                  .map((doctor, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{doctor.name}</td>
                      <td>{doctor.regNo}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3 className="footer-heading">Naturopathy Registration Board</h3>
            <p className="footer-desc">
              Regulating and promoting excellence in Naturopathy education and practice across India.
            </p>
            <div className="footer-logos">
              <img src="img/nrb.png" alt="NRB Logo" className="footer-logo" />
              <img src="img/MOA.png" alt="Ministry Logo" className="footer-logo" />
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about-us">About NRB</a></li>
              <li><a href="/constitution">Constitution of NRB</a></li>
              <li><a href="/doctors-list">List of Doctors Registered</a></li>
              <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Important Links</h4>
            <ul className="footer-links">
              <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
              <li><a href="/gallery">News &amp; Events</a></li>
              <li><a href="/state-boards">State Registration Board</a></li>
              <li><a href="/medical-colleges">Medical Colleges</a></li>
              <li><a href="/who-naturopathic-workforce">WHO Naturopathic Workforce</a></li>
              <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact Information</h4>
            <div className="footer-contact">
              <p>Dr Kajal Gupta (Domain Expert), NRB</p>
              <p>📧 nrb@bharatmail.co.in</p>
              <p>📞 86258 33306</p>
              <p>🕐 Mon-Fri: 10:00 AM - 6:00 PM</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Naturopathy Registration Board. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#privacy">Privacy Policy</a>
            <span>|</span>
            <a href="#terms">Terms & Conditions</a>
            <span>|</span>
            <a href="#sitemap">Sitemap</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default DoctorsList;


